<div class="hrz-start center-align-items pos-rel">
	<input type="checkbox" [checked]="checked">
	<label *ngIf="label">{{label}}</label>
	<div class="check-cover" (click)="toggleChecked()"></div>
</div>
